<script>
export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  filters: {
    fullName(account) {
      return (
        account.first_name.toUpperCase() + " " + account.last_name.toUpperCase()
      );
    }
  }
};
</script>

<template>
  <section>
    <img :src="account.profile.profile_picture" />
    <h1>{{account | fullName}}</h1>
  </section>
</template>

<style scoped>
img {
  height: 60px;
  width: 60px;
  object-fit: cover;
  border-radius: 50px;
  box-shadow: 4px 4px 22px -7px rgba(0, 0, 0, 0.5);
}

h1 {
  margin: 10px 0;
  font-size: 14px;
  text-transform: uppercase;
  color: var(--purple);
}

@media (min-width: 920px) {
  img {
    height: 100px;
    width: 100px;
  }

  h1 {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Profile.vue